import { render, staticRenderFns } from "./manageAddress.vue?vue&type=template&id=326f858d&scoped=true&"
import script from "./manageAddress.vue?vue&type=script&lang=js&"
export * from "./manageAddress.vue?vue&type=script&lang=js&"
import style0 from "./manageAddress.vue?vue&type=style&index=0&lang=css&"
import style1 from "./manageAddress.vue?vue&type=style&index=1&id=326f858d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f858d",
  null
  
)

export default component.exports